import { Injectable } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { simplify } from '../shared/functions/meta.functions';
import { SearchMode } from '../shared/enum/searchMode';

@Injectable()
export class GwrFormService {
  private markFormAsTouched(form: NgForm) {
    for (const control of Object.values(form.controls)) {
      control.markAsTouched();
    }
  }

  public submit(form: NgForm, searchMode: SearchMode, request, router: Router, route: ActivatedRoute, markAsTouched: boolean) {
    if (form.invalid) {
      return;
    }
    if (markAsTouched) {
      this.markFormAsTouched(form);
    }
    if (form.controls.eproid && form.controls.eproid.value) {
      router.navigate(['./detail', form.controls.eproid.value], {
        relativeTo: route
      });
    } else if (form.controls.baudossierNummer) {
      router.navigate(['./detail'], {
        relativeTo: route,
        queryParams: { request: JSON.stringify(simplify(request)) }
      });
    } else {
      router.navigate(['./list', searchMode], {
        relativeTo: route,
        queryParams: { request: JSON.stringify(simplify(request)) }
      });
    }
  }
}
